import { ROLES, type UserRole } from "@/constants/roles";

import type { User } from "@/types/user";

export const hasRole = (user: User | undefined, role: UserRole): boolean => {
  if (!user?.role) return false;
  return user.role === role;
};

export const isAdmin = (user: User | undefined): boolean => {
  return hasRole(user, ROLES.ADMIN);
};
